/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AIModelTabEnum {
  ARTIST_TAG = "ARTIST_TAG",
  MODEL_TAG = "MODEL_TAG",
  SQUARE_CREATE_TAG = "SQUARE_CREATE_TAG",
  STYLE = "STYLE",
}

export enum AccountCycleTypeEnum {
  DAY = "DAY",
  HOUR = "HOUR",
  MONTH = "MONTH",
  NONE = "NONE",
  SYNC = "SYNC",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export enum AccountGroupTypeEnum {
  AI_PRO_ACCOUNT = "AI_PRO_ACCOUNT",
  BALANCE_WALLET = "BALANCE_WALLET",
  BLANK_PASS = "BLANK_PASS",
  BRONZE_CARD = "BRONZE_CARD",
  GOLD_CARD = "GOLD_CARD",
  HS_ACCOUNT = "HS_ACCOUNT",
  MIRROR_ACCOUNT = "MIRROR_ACCOUNT",
  ORIGIN_CARD = "ORIGIN_CARD",
  PLATINUM_CARD = "PLATINUM_CARD",
  POINT_WALLET = "POINT_WALLET",
  SILVER_CARD = "SILVER_CARD",
  TEMPORARY_ACCOUNT = "TEMPORARY_ACCOUNT",
  WJ_AI_MEMBER = "WJ_AI_MEMBER",
  WJ_AI_PRO_MEMBER = "WJ_AI_PRO_MEMBER",
  XY_POINT = "XY_POINT",
}

export enum AccountSource {
  BOUGHT = "BOUGHT",
  RECEIVE = "RECEIVE",
}

export enum ActionType {
  CANCEL = "CANCEL",
  CONFIRM = "CONFIRM",
}

/**
 * 受影响对象类型
 */
export enum AffectedType {
  ACTIVITY = "ACTIVITY",
  AI_ARTWORK = "AI_ARTWORK",
  AI_COLLECTION = "AI_COLLECTION",
  AI_COMIC = "AI_COMIC",
  AI_COMPETITION = "AI_COMPETITION",
  ANNUAL_REPORT = "ANNUAL_REPORT",
  ARTWORK = "ARTWORK",
  BOUNTY = "BOUNTY",
  CHANNEL = "CHANNEL",
  COMMENT = "COMMENT",
  EXTERNAL_AI_ARTWORK = "EXTERNAL_AI_ARTWORK",
  NOTE = "NOTE",
  STYLE_MODEL = "STYLE_MODEL",
  VIDEO = "VIDEO",
  VOTE = "VOTE",
  WORKFLOW = "WORKFLOW",
}

/**
 * ai画作的生成状态
 */
export enum AiArtWorkStatus {
  CANCEL = "CANCEL",
  CLEAN = "CLEAN",
  FAIL = "FAIL",
  FILED = "FILED",
  FILE_FAIL = "FILE_FAIL",
  FILING = "FILING",
  GENERATEING = "GENERATEING",
  NIGHT = "NIGHT",
  PREPARING = "PREPARING",
  QUEUEING = "QUEUEING",
  REJECTED = "REJECTED",
  SUCCESS = "SUCCESS",
  TIDAL = "TIDAL",
  UNGENERATE = "UNGENERATE",
}

/**
 * 申诉场景
 */
export enum AiArtworkAppealScene {
  COMPETITION = "COMPETITION",
  SQUARE = "SQUARE",
}

/**
 * ai作画选项类型
 */
export enum AiArtworkOptionTypeEnum {
  AI_LAB_TAB = "AI_LAB_TAB",
  ARTIST = "ARTIST",
  ART_GENRE = "ART_GENRE",
  ART_SKILL = "ART_SKILL",
  ART_STYLE = "ART_STYLE",
  CHARACTER = "CHARACTER",
  CUSTOM_STYLE_PARAM = "CUSTOM_STYLE_PARAM",
  ELEMENT_MAGIC = "ELEMENT_MAGIC",
  IMAGE_TYPE = "IMAGE_TYPE",
  IMAGE_TYPE_MODEL_TAG = "IMAGE_TYPE_MODEL_TAG",
  IMAGE_TYPE_MODEL_TAG_COMPLEX = "IMAGE_TYPE_MODEL_TAG_COMPLEX",
  MODEL_FUSION = "MODEL_FUSION",
  MODEL_THEME = "MODEL_THEME",
  STYLE = "STYLE",
  STYLE_MODEL = "STYLE_MODEL",
  THEME_STYLE = "THEME_STYLE",
}

/**
 * 排序规则
 */
export enum AiArtworkOrderMode {
  COLLECTION_COVER = "COLLECTION_COVER",
  CREATETIME = "CREATETIME",
  DEFAULT = "DEFAULT",
  IDASC = "IDASC",
}

export enum AiArtworkPromptEnum {
  INPUT_PROMPT = "INPUT_PROMPT",
  INPUT_PROMPT_DD = "INPUT_PROMPT_DD",
}

export enum AiArtworkSameType {
  COMPLETELY_SAME = "COMPLETELY_SAME",
  CREATE_LIKEWISE = "CREATE_LIKEWISE",
  PICTURE_SAME = "PICTURE_SAME",
  PREFINE_SAME = "PREFINE_SAME",
  REPAIR_HAND = "REPAIR_HAND",
  SVD_SAME = "SVD_SAME",
}

/**
 * ai作品的业务状态
 */
export enum AiArtworkServiceStatus {
  CLEANED = "CLEANED",
  GENERAL = "GENERAL",
  WORKFLOW_PROCESS = "WORKFLOW_PROCESS",
}

/**
 * AI 作品业务状态
 */
export enum AiArtworkServiceTypeGraphQLEnum {
  NORMAL = "NORMAL",
  PROFESSIONAL = "PROFESSIONAL",
}

/**
 * ai作品分享源
 */
export enum AiArtworkShareSource {
  AI_ARTWORK = "AI_ARTWORK",
  AI_ARTWORK_PRO = "AI_ARTWORK_PRO",
  SQUARE_POST = "SQUARE_POST",
}

export enum AiArtworkSource {
  EXTERNAL = "EXTERNAL",
  INSIDE = "INSIDE",
}

/**
 * 浏览者身份
 */
export enum AiArtworkViewUser {
  CREATOR = "CREATOR",
  OWNER = "OWNER",
}

export enum AiCollectionVisibleType {
  MATERIAL = "MATERIAL",
  NOT_VISIBLE = "NOT_VISIBLE",
  SQUARE = "SQUARE",
}

/**
 * ai作画模型
 */
export enum AiCreateArtworkModel {
  ANIME_DIFFUSION = "ANIME_DIFFUSION",
  DELETED = "DELETED",
  DISCO_DIFFUSION = "DISCO_DIFFUSION",
  HIDDEN = "HIDDEN",
  INDUSTRY = "INDUSTRY",
  MIDJOURNEY = "MIDJOURNEY",
  PRETEND_MJ = "PRETEND_MJ",
  STABLE_DIFFUSION = "STABLE_DIFFUSION",
  STYLE = "STYLE",
}

/**
 * ai作画模式
 */
export enum AiCreateArtworkPattern {
  ANY_TEXT = "ANY_TEXT",
  CANNY = "CANNY",
  DEPTH = "DEPTH",
  DEPTH2IMG = "DEPTH2IMG",
  GENERAL = "GENERAL",
  HED = "HED",
  INSTANT_ID = "INSTANT_ID",
  LAYER_DIFFUSION = "LAYER_DIFFUSION",
  MASK = "MASK",
  MLSD = "MLSD",
  NORMAL = "NORMAL",
  OPENPOSE = "OPENPOSE",
  SCRIBBLE = "SCRIBBLE",
  SEG = "SEG",
}

/**
 * ai丹炉操作类型
 */
export enum AiDanluOperateType {
  FAIL = "FAIL",
  SUCCESS = "SUCCESS",
  WARN = "WARN",
}

/**
 * ai丹炉状态
 */
export enum AiDanluStatus {
  FAIL = "FAIL",
  SHUTDOWN = "SHUTDOWN",
  STARTING = "STARTING",
  START_TIMEOUT = "START_TIMEOUT",
  SUCCESS = "SUCCESS",
  UN_RUN = "UN_RUN",
}

export enum AiItemPostTargetEnum {
  BACKGROUND_IMAGE = "BACKGROUND_IMAGE",
  BLENDING_IMAGE = "BLENDING_IMAGE",
  END_IMAGE = "END_IMAGE",
  FOREGROUND_IMAGE = "FOREGROUND_IMAGE",
  INIT_IMAGE = "INIT_IMAGE",
  MASK_IMAGE = "MASK_IMAGE",
  REFERENCE_IMAGE = "REFERENCE_IMAGE",
  START_IMAGE = "START_IMAGE",
}

export enum AiSubdivisionType {
  CAMERA = "CAMERA",
  CONTROL_NET = "CONTROL_NET",
  HAND_FIX = "HAND_FIX",
  IC_LIGHT = "IC_LIGHT",
  IMG_TO_IMG = "IMG_TO_IMG",
  INFINITE_ZOOM = "INFINITE_ZOOM",
  INPAINTING = "INPAINTING",
  REFERENCE = "REFERENCE",
  SEGMENTATION = "SEGMENTATION",
  STEREOSCOPIC_IMAGE = "STEREOSCOPIC_IMAGE",
  SUPERSIZE = "SUPERSIZE",
  SVD = "SVD",
  TEXT_TO_IMG = "TEXT_TO_IMG",
  TEXT_TO_VIDEO = "TEXT_TO_VIDEO",
  TILED_DIFFUSION = "TILED_DIFFUSION",
  VECTOR_STUDIO = "VECTOR_STUDIO",
  VIDEO_TO_VIDEO = "VIDEO_TO_VIDEO",
}

export enum AiTypeEnum {
  AI_LAB_INFINITE_ZOOM = "AI_LAB_INFINITE_ZOOM",
  AI_LAB_SEGMENTATION = "AI_LAB_SEGMENTATION",
  AI_SVD = "AI_SVD",
  AVATAR_ARTWORK = "AVATAR_ARTWORK",
  CAMERA = "CAMERA",
  INSTANT_ID = "INSTANT_ID",
  MJ_DESCRIBE = "MJ_DESCRIBE",
  PICTURE = "PICTURE",
  STEREOSCOPIC_IMAGE = "STEREOSCOPIC_IMAGE",
  SUPER_SIZE = "SUPER_SIZE",
  TEXT_TO_VIDEO = "TEXT_TO_VIDEO",
  VECTOR = "VECTOR",
  VIDEO = "VIDEO",
}

/**
 * Ai生成违规退还状态
 */
export enum AiViolationRefundStatus {
  NOT_REFUND = "NOT_REFUND",
  REFUND = "REFUND",
}

export enum AnyTextMode {
  EDIT = "EDIT",
  GEN = "GEN",
}

export enum AppRechargeOrderStatusEnum {
  CANCEL = "CANCEL",
  COMPLETED = "COMPLETED",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  REFUNDED = "REFUNDED",
  WAIT = "WAIT",
}

/**
 * 作品数据库记录的类型
 */
export enum ArtworkDBType {
  AI_COMPETITION = "AI_COMPETITION",
  AI_COPYRIGHT = "AI_COPYRIGHT",
  EVIDENCE = "EVIDENCE",
  NORMAL = "NORMAL",
  VIDEO_COMPETITION = "VIDEO_COMPETITION",
}

export enum ArtworkKeywordType {
  ALL = "ALL",
  ARTWORK_NAME = "ARTWORK_NAME",
}

/**
 * 排序
 */
export enum ArtworkSortEnum {
  CREATE_TIME = "CREATE_TIME",
  DEFAULT = "DEFAULT",
  HOT = "HOT",
  PRICE = "PRICE",
  SERIES_SORT = "SERIES_SORT",
  VERIFY_TIME = "VERIFY_TIME",
  VOTES = "VOTES",
}

/**
 * 作品状态枚举 注：此枚举目前至少在dof和water服务中都有用到，当此枚举发生变更时，需要将所有使用到它的服务重新发布后，Federation才能刷新成功
 */
export enum ArtworkStatusEnum {
  ACCEPT = "ACCEPT",
  ALL = "ALL",
  NOT_VISIBLE = "NOT_VISIBLE",
  REFUSE = "REFUSE",
  UN_WAIT = "UN_WAIT",
  VISIBLE = "VISIBLE",
  WAIT = "WAIT",
  WAIT_AND_ACCEPT = "WAIT_AND_ACCEPT",
  WAIT_GET = "WAIT_GET",
}

export enum BaseMsgType {
  AI_CREATION = "AI_CREATION",
  AI_PROFESSIONAL_EDITION = "AI_PROFESSIONAL_EDITION",
  ATTENTION = "ATTENTION",
  CL = "CL",
  COLLECT = "COLLECT",
  COMMENT = "COMMENT",
  CONTENT_SUBMISSION = "CONTENT_SUBMISSION",
  COPY = "COPY",
  DRAFT = "DRAFT",
  LIKES = "LIKES",
  MY_EARNINGS = "MY_EARNINGS",
  SCIENTIFIC = "SCIENTIFIC",
  SERVICE_FEEDBACK = "SERVICE_FEEDBACK",
}

export enum BountyAnswerType {
  AI_ARTWORK = "AI_ARTWORK",
  AI_ARTWORK_NOT_VISIAbLE = "AI_ARTWORK_NOT_VISIAbLE",
  NORMAL = "NORMAL",
  VIDEO = "VIDEO",
}

export enum BountyAnswerUserType {
  ALL = "ALL",
  FOCUS = "FOCUS",
}

export enum CardStatus {
  EFFECTIVE = "EFFECTIVE",
  EXPIRE = "EXPIRE",
  NOT_ACTIVE = "NOT_ACTIVE",
}

export enum Channel {
  ANDROID = "ANDROID",
  H5 = "H5",
  IOS = "IOS",
  WEB = "WEB",
}

export enum ChatMessageStatusEnum {
  CANCEL = "CANCEL",
  ERROR = "ERROR",
  FINISH = "FINISH",
  INIT = "INIT",
}

export enum ChatModelEnum {
  DEEP_SEEK_R1 = "DEEP_SEEK_R1",
  DEEP_SEEK_V3 = "DEEP_SEEK_V3",
  GPT4O_IMAGE = "GPT4O_IMAGE",
}

export enum ClipType {
  FLUX = "FLUX",
  SD3 = "SD3",
  SDXL = "SDXL",
}

export enum ComicCollectTypeEnum {
  INSTALMENTS = "INSTALMENTS",
  NO_INSTALMENTS = "NO_INSTALMENTS",
}

export enum ComicCollectUpdateTypeEnum {
  DAY = "DAY",
  FINISH = "FINISH",
  NO_TIME = "NO_TIME",
  WEEK = "WEEK",
  WORK_DAY = "WORK_DAY",
}

export enum CommentStatusEnum {
  PUBLISH = "PUBLISH",
  TOBE_PUBLISH = "TOBE_PUBLISH",
}

export enum CompanyIntentionType {
  MIRROR = "MIRROR",
  WJAI = "WJAI",
}

export enum CompetitionType {
  AI_ARTWORK = "AI_ARTWORK",
  DRAFT = "DRAFT",
  OUTSIDE = "OUTSIDE",
  VIDEO = "VIDEO",
}

export enum ContentTypeEnum {
  TEXT = "TEXT",
  WEBPAGE = "WEBPAGE",
}

export enum ContestType {
  AI_CREATION = "AI_CREATION",
}

export enum ControlNetPulidMode {
  EXTREMELY = "EXTREMELY",
  FIDELITY = "FIDELITY",
}

export enum ControlShowType {
  COMPOSITION = "COMPOSITION",
  FACEID = "FACEID",
  STYLE = "STYLE",
}

export enum ConversationType {
  DEEPSEEK = "DEEPSEEK",
  GPT = "GPT",
  GPT_IMAGE_1 = "GPT_IMAGE_1",
}

/**
 * 搜索内容
 */
export enum CopyrightAiSearchContent {
  IMAGE = "IMAGE",
  PROMPT = "PROMPT",
}

/**
 * 描述语言
 */
export enum CopyrightAiSearchLanguage {
  CHINESE = "CHINESE",
  ENGLISH = "ENGLISH",
}

/**
 * 无界 AI 搜索范围
 */
export enum CopyrightAiSearchScope {
  AI_SQUARE = "AI_SQUARE",
}

/**
 * 无界 AI 排序
 */
export enum CopyrightAiSort {
  COLLECT_COUNT = "COLLECT_COUNT",
  COMPREHENSIVE = "COMPREHENSIVE",
  HOT = "HOT",
  LATEST = "LATEST",
  LIKE_COUNT = "LIKE_COUNT",
  OP_RECOMMEND = "OP_RECOMMEND",
  SAME_MOST = "SAME_MOST",
}

/**
 * 用户认证状态
 */
export enum CopyrightAuthStatus {
  AUTH = "AUTH",
  AUTH_FAIL = "AUTH_FAIL",
  AUTH_ING = "AUTH_ING",
  NOT_AUTH = "NOT_AUTH",
}

/**
 * 用户头像类型
 */
export enum CopyrightUserAvatarType {
  AI_ARTWORK = "AI_ARTWORK",
  PRODUCTION = "PRODUCTION",
  SYSTEM = "SYSTEM",
}

/**
 * 用户类型
 */
export enum CopyrightUserType {
  COMPANY = "COMPANY",
  COMPANY_API = "COMPANY_API",
  PERSONAL = "PERSONAL",
}

export enum EvaluationScoreEnum {
  FIVE_STARS = "FIVE_STARS",
  FOUR_STARS = "FOUR_STARS",
  ONE_STAR = "ONE_STAR",
  THREE_STARS = "THREE_STARS",
  TWO_STARS = "TWO_STARS",
}

export enum FileType {
  MODEL = "MODEL",
}

/**
 * 关注状态
 */
export enum FollowStatus {
  HE_ONE_WAY = "HE_ONE_WAY",
  ME_ONE_WAY = "ME_ONE_WAY",
  NON = "NON",
  TWO_WAY = "TWO_WAY",
}

export enum Frequency {
  DAILY_FIRST_TIME = "DAILY_FIRST_TIME",
  EVERY_TIME = "EVERY_TIME",
  FIRST_TIME = "FIRST_TIME",
}

export enum FromEnum {
  ANDROID = "ANDROID",
  H5 = "H5",
  WEB = "WEB",
  iOS = "iOS",
}

/**
 * 积分账单事件类型
 */
export enum IntegralBillEventType {
  CONSUME = "CONSUME",
  FROZEN = "FROZEN",
  RECEIVE = "RECEIVE",
}

/**
 * 积分任务完成状态
 */
export enum IntegralTaskStatus {
  RECEIVED = "RECEIVED",
  RECEIVING = "RECEIVING",
  UNDONE = "UNDONE",
}

/**
 * 邀请奖励类型
 */
export enum InviteBonusType {
  DURATION_PRO = "DURATION_PRO",
  INTEGRAL = "INTEGRAL",
  MONEY = "MONEY",
}

/**
 * 邀请类型
 */
export enum InviteType {
  ARTIST = "ARTIST",
  REGISTER = "REGISTER",
}

export enum InvolveYellow {
  APPEAL_PASS = "APPEAL_PASS",
  FAIL = "FAIL",
  FLAG = "FLAG",
  FLAG_REVIEW = "FLAG_REVIEW",
  NOT = "NOT",
  POLITICS = "POLITICS",
  POLITICS_REVIEW = "POLITICS_REVIEW",
  PORN = "PORN",
  PORN_REVIEW = "PORN_REVIEW",
  SEXY = "SEXY",
  SEXY_REVIEW = "SEXY_REVIEW",
  TEXT_POLITICS = "TEXT_POLITICS",
  TEXT_POLITICS_REVIEW = "TEXT_POLITICS_REVIEW",
}

/**
 * 跳转作品
 */
export enum JumpType {
  AI_COMIC = "AI_COMIC",
  ARTWORK = "ARTWORK",
  BOUNTY = "BOUNTY",
  COLLECTION = "COLLECTION",
  COMMENT = "COMMENT",
  POST_ACTIVITY = "POST_ACTIVITY",
  POST_AI_ARTWORK = "POST_AI_ARTWORK",
  POST_NOTE = "POST_NOTE",
  SQUARE_WORKFLOW = "SQUARE_WORKFLOW",
  VIDEO = "VIDEO",
  VOTE = "VOTE",
}

/**
 * 支持的语言
 */
export enum Language {
  CHINESE = "CHINESE",
  ENGLISH = "ENGLISH",
}

/**
 * 登录所需unique code状态
 */
export enum LoginSerialNumberStatus {
  EXPIRED = "EXPIRED",
  LOGIN = "LOGIN",
  NO_BIND = "NO_BIND",
  NO_LOGIN = "NO_LOGIN",
  SCAN_CODE = "SCAN_CODE",
}

export enum MemberCardRightTypeEnum {
  ACCELERATE = "ACCELERATE",
  AI_ADVANCED_SETTING = "AI_ADVANCED_SETTING",
  AI_ARTIST_CERTIFY = "AI_ARTIST_CERTIFY",
  AI_ARTWORK_TRAIN = "AI_ARTWORK_TRAIN",
  AI_AVATAR_AI_CREATE_EQUITY = "AI_AVATAR_AI_CREATE_EQUITY",
  AI_CHAT_GPT = "AI_CHAT_GPT",
  AI_CREATE = "AI_CREATE",
  AI_CREATE_SPACE = "AI_CREATE_SPACE",
  AI_CUSTOMER_SERVICE = "AI_CUSTOMER_SERVICE",
  AI_EXCLUSIVE_MODEL = "AI_EXCLUSIVE_MODEL",
  AI_EXQUISITE_PAINTING_DISCOUNT = "AI_EXQUISITE_PAINTING_DISCOUNT",
  AI_GIFT_INTEGRAL = "AI_GIFT_INTEGRAL",
  AI_MEMBER_ICON = "AI_MEMBER_ICON",
  AI_MEMBER_PLAN = "AI_MEMBER_PLAN",
  AI_PRO_GIFT_DURATION = "AI_PRO_GIFT_DURATION",
  AI_SPELL_ANALYSE = "AI_SPELL_ANALYSE",
  AI_TIDAL_UNLIMITED_CREATE = "AI_TIDAL_UNLIMITED_CREATE",
  EVIDENCE_CREATE = "EVIDENCE_CREATE",
  MEETING_ENTRANCE_TICKET = "MEETING_ENTRANCE_TICKET",
  MIRROR_AI_CREATE_TIMES = "MIRROR_AI_CREATE_TIMES",
  OFFLINE_SALON = "OFFLINE_SALON",
  SUPER_RESOLUTION = "SUPER_RESOLUTION",
  TEMPORARY_DEEPSEEK_CHANNEL = "TEMPORARY_DEEPSEEK_CHANNEL",
  TEMPORARY_DURATION = "TEMPORARY_DURATION",
  TEMPORARY_INTEGRAL = "TEMPORARY_INTEGRAL",
  TEMPORARY_MIDJOURNEY_CHANNEL = "TEMPORARY_MIDJOURNEY_CHANNEL",
  TEMPORARY_MIRROR_CHANNEL = "TEMPORARY_MIRROR_CHANNEL",
  TEMPORARY_NANO_BANANA_CHANNEL = "TEMPORARY_NANO_BANANA_CHANNEL",
  TEMPORARY_WUJIEAI_CHANNEL = "TEMPORARY_WUJIEAI_CHANNEL",
}

/**
 * 手机验证码类型
 */
export enum MobileVerifyType {
  SMS = "SMS",
  VOICE = "VOICE",
}

/**
 * 消息中心版本
 */
export enum MsgCenterVersion {
  V1 = "V1",
  V2 = "V2",
}

/**
 * 消息类型
 */
export enum MsgType {
  BBS = "BBS",
  NEWS = "NEWS",
  PLATFORM_ANNOUNCEMENT = "PLATFORM_ANNOUNCEMENT",
  SYSTEM = "SYSTEM",
  UNKNOWN = "UNKNOWN",
}

export enum MuzzleBizType {
  AI_ARTWORK = "AI_ARTWORK",
  AI_COLLECTION = "AI_COLLECTION",
  AI_COMIC = "AI_COMIC",
  BOUNTY = "BOUNTY",
  COMMENT = "COMMENT",
  DEL_POST = "DEL_POST",
  NOTE = "NOTE",
  VIDEO = "VIDEO",
  VOTE = "VOTE",
  WORKFLOW = "WORKFLOW",
}

/**
 * 禁言时间类型
 */
export enum MuzzleTimeType {
  ONE_DAYS = "ONE_DAYS",
  PERMANENT = "PERMANENT",
  SEVEN_DAYS = "SEVEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
  THREE_DAYS = "THREE_DAYS",
}

/**
 * 轮询状态
 */
export enum OptPromptResultStatus {
  FAIL = "FAIL",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
}

export enum OrderStatusEnum {
  CANCEL = "CANCEL",
  FINISH = "FINISH",
  PAYING = "PAYING",
  REFUNDING = "REFUNDING",
  REFUND_PAY = "REFUND_PAY",
  WAIT_DELIVERY = "WAIT_DELIVERY",
  WAIT_PAY = "WAIT_PAY",
  WAIT_RECEIVE = "WAIT_RECEIVE",
}

/**
 * 不同用途的bucket枚举
 */
export enum OssBucket {
  NEWS = "NEWS",
  TRADE_PRIVATE = "TRADE_PRIVATE",
  TRADE_PROTECT = "TRADE_PROTECT",
  TRADE_RESOURCE = "TRADE_RESOURCE",
}

export enum PayChannelEnum {
  ALI_PAY = "ALI_PAY",
  CASHIER_PAY = "CASHIER_PAY",
  IAP = "IAP",
  UNION_PAY = "UNION_PAY",
  WX_PAY = "WX_PAY",
}

export enum PayScene {
  ACCOUNT_SPLITTING = "ACCOUNT_SPLITTING",
  ORIGIN = "ORIGIN",
  SHEN_YIN = "SHEN_YIN",
  SHEN_YIN_WX = "SHEN_YIN_WX",
}

export enum PostActivityWay {
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
}

export enum PostImageSourceType {
  AI_ARTWORK = "AI_ARTWORK",
  AI_LAB_SVD_GIF = "AI_LAB_SVD_GIF",
  USER = "USER",
  WORKFLOW_PIC = "WORKFLOW_PIC",
  WORKFLOW_VIDEO = "WORKFLOW_VIDEO",
}

export enum PostKeyWordType {
  DEFAULT = "DEFAULT",
  PROMPT = "PROMPT",
  TITLE = "TITLE",
}

/**
 * 笔记排序字段
 */
export enum PostSortField {
  BOUNTY_INTEGRAL = "BOUNTY_INTEGRAL",
  COLLECT_COUNT = "COLLECT_COUNT",
  CREATE_TIME = "CREATE_TIME",
  END_TIME = "END_TIME",
  LIKE_COUNT = "LIKE_COUNT",
  OP_RECOMMEND = "OP_RECOMMEND",
  RECOMMEND = "RECOMMEND",
  RECOMMEND_V2 = "RECOMMEND_V2",
  SAME_COUNT = "SAME_COUNT",
  SCORE = "SCORE",
  SEARCH_DEFAULT = "SEARCH_DEFAULT",
}

/**
 * 各种资讯的状态
 */
export enum PostStatus {
  AUTO_DRAFT = "AUTO_DRAFT",
  DRAFT = "DRAFT",
  FUTURE = "FUTURE",
  FUTURE_OVERSEAS = "FUTURE_OVERSEAS",
  INHERIT = "INHERIT",
  OFFLINE = "OFFLINE",
  PENDING = "PENDING",
  PRIVATE = "PRIVATE",
  PUBLISH = "PUBLISH",
  PUBLISH_DOMESTIC = "PUBLISH_DOMESTIC",
  PUBLISH_OVERSEAS = "PUBLISH_OVERSEAS",
  TRASH = "TRASH",
}

export enum PostTimeFilter {
  ALL = "ALL",
  WEEK = "WEEK",
}

export enum PostVoteResultShowEnum {
  end_show = "end_show",
  vote_show = "vote_show",
}

export enum PostVoteRuleEnum {
  ALL_USER = "ALL_USER",
  FOLLOWED = "FOLLOWED",
}

export enum PostVoteTypeEnum {
  IMAGE_WORD = "IMAGE_WORD",
  WORD = "WORD",
}

export enum PretreatmentMethod {
  FAKE_SCRIBBLE = "FAKE_SCRIBBLE",
  INVERT_SCRIBBLE = "INVERT_SCRIBBLE",
  NONE = "NONE",
  SCRIBBLE = "SCRIBBLE",
}

/**
 * 查询时间枚举
 */
export enum QueryDateEnum {
  ALL_TIME = "ALL_TIME",
  FOURTEEN_DAYS = "FOURTEEN_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
}

/**
 * 排队方式，影响进队列的方式，也会影响积分扣除
 */
export enum QueueType {
  NIGHT = "NIGHT",
  NORMAL = "NORMAL",
  TIDAL = "TIDAL",
}

/**
 * 榜单类型
 */
export enum RankType {
  COLLECT = "COLLECT",
  LIKE = "LIKE",
  SAME_STYLE = "SAME_STYLE",
}

/**
 * 风控状态
 */
export enum RiskControlStatus {
  ALLOW_USE = "ALLOW_USE",
  APPEAL_PROCESSING = "APPEAL_PROCESSING",
  APPEAL_REFUSE = "APPEAL_REFUSE",
  BE_REPORTED = "BE_REPORTED",
  NEED_APPEAL = "NEED_APPEAL",
  NOT_ALLOW_USE = "NOT_ALLOW_USE",
  NO_RECORD = "NO_RECORD",
}

export enum Scene {
  AI_ARTWORK = "AI_ARTWORK",
  AI_ARTWORK_COLLECTION = "AI_ARTWORK_COLLECTION",
  APP_SHARE_AI_ARTWORK_TITLE = "APP_SHARE_AI_ARTWORK_TITLE",
  AVATAR_TRAIN = "AVATAR_TRAIN",
  LORA_TRAIN_DATA_SET_IMAGE = "LORA_TRAIN_DATA_SET_IMAGE",
  SQUARE_EXTERNAL_VIDEO = "SQUARE_EXTERNAL_VIDEO",
  SQUARE_POST = "SQUARE_POST",
  VIDEO_GENRATE_VIDEO_UPLOAD_VIDEO = "VIDEO_GENRATE_VIDEO_UPLOAD_VIDEO",
}

export enum Scheduler {
  BETA = "BETA",
  DDIM_UNIFORM = "DDIM_UNIFORM",
  EXPONENTIAL = "EXPONENTIAL",
  KARRAS = "KARRAS",
  NORMAL = "NORMAL",
  SGM_UNIFORM = "SGM_UNIFORM",
  SIMPLE = "SIMPLE",
}

export enum SearchUploaderType {
  COMPANY = "COMPANY",
  PERSONAL = "PERSONAL",
}

export enum ShowStatusEnum {
  SHOW = "SHOW",
  UN_SHOW = "UN_SHOW",
}

export enum SocialType {
  COLLECT = "COLLECT",
  FOLLOW = "FOLLOW",
  LIKE = "LIKE",
}

export enum SocialViewType {
  AI_CREATION = "AI_CREATION",
  COMMON = "COMMON",
  COMPETITION = "COMPETITION",
  MODEL = "MODEL",
  SQUARE = "SQUARE",
  SQUARE_VOTE = "SQUARE_VOTE",
}

export enum SortField {
  CREATE_TIME = "CREATE_TIME",
  FREQUENCY = "FREQUENCY",
}

export enum SortType {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * 贴子关联源类型
 */
export enum SourceType {
  ACTIVITY = "ACTIVITY",
  AI_ARTWORK = "AI_ARTWORK",
  AI_COLLECTION = "AI_COLLECTION",
  AI_LAB_SVD = "AI_LAB_SVD",
  AI_VIDEO = "AI_VIDEO",
  ARTWORK = "ARTWORK",
  BOUNTY = "BOUNTY",
  LOCAL_VIDEO = "LOCAL_VIDEO",
  POST = "POST",
  TEXT_VIDEO = "TEXT_VIDEO",
  WORKFLOW = "WORKFLOW",
}

/**
 * 需要服务端关注的特殊图片标记
 * 不要改名，因为实际使用的时候用的name
 */
export enum SpecialImageTagEnum {
  GRID_IMAGE = "GRID_IMAGE",
}

export enum SpellAnalysisCreateChannel {
  ORDINARY = "ORDINARY",
  PRO = "PRO",
  TMP = "TMP",
  TOB = "TOB",
}

/**
 * 咒语解析状态
 */
export enum SpellAnalysisGenerateStatus {
  FAIL = "FAIL",
  ING = "ING",
  SUCCESS = "SUCCESS",
}

export enum SpellAnalysisImgType {
  COMPOSITION = "COMPOSITION",
  FACEID = "FACEID",
  REFERENCE = "REFERENCE",
  STYLE = "STYLE",
}

/**
 * 广场元素类型
 */
export enum SquareItemType {
  ACTIVITY = "ACTIVITY",
  AI_ARTWORK = "AI_ARTWORK",
  AI_COLLECTION = "AI_COLLECTION",
  AI_COMIC = "AI_COMIC",
  BOUNTY = "BOUNTY",
  COMPETITION = "COMPETITION",
  NEWS = "NEWS",
  NOTE = "NOTE",
  VIDEO = "VIDEO",
  VOTE = "VOTE",
  WORKFLOW = "WORKFLOW",
}

export enum SquarePostScope {
  EXTERNAL = "EXTERNAL",
  INSIDE = "INSIDE",
}

/**
 * 贴子状态
 */
export enum SquarePostStatus {
  ACCEPT = "ACCEPT",
  AUTO_REFUSE = "AUTO_REFUSE",
  REFUSE = "REFUSE",
  WAIT = "WAIT",
}

/**
 * 贴子类型
 */
export enum SquarePostType {
  ACTIVITY = "ACTIVITY",
  AI_ARTWORK = "AI_ARTWORK",
  AI_COLLECTION = "AI_COLLECTION",
  AI_COMIC = "AI_COMIC",
  BOUNTY = "BOUNTY",
  DRAFT = "DRAFT",
  NOTE = "NOTE",
  VIDEO = "VIDEO",
  VOTE = "VOTE",
  WORKFLOW = "WORKFLOW",
}

export enum StartStatusEnum {
  COMPETITION_RESULT = "COMPETITION_RESULT",
  CONTRIBUTE_START = "CONTRIBUTE_START",
  END = "END",
  ING = "ING",
  WAIT = "WAIT",
}

/**
 * 超分辨的状态
 */
export enum SuperSizeStatus {
  FAIL = "FAIL",
  QUEUE = "QUEUE",
  SUCCESS = "SUCCESS",
  SUPERING = "SUPERING",
  UNSUPER = "UNSUPER",
}

export enum SuperType {
  FOUR_K = "FOUR_K",
  PREFINE = "PREFINE",
  SUPERSIZE = "SUPERSIZE",
}

/**
 * tag模型分类(该模型与作画模型无关)
 */
export enum TagModelCategory {
  ANIME = "ANIME",
  CRYPTO_ART = "CRYPTO_ART",
  FEMALE_CARTOON = "FEMALE_CARTOON",
  GENERAL = "GENERAL",
  HANFU_MODEL = "HANFU_MODEL",
  INTERIOR_DESIGN = "INTERIOR_DESIGN",
  PHOTOGRAPHIC = "PHOTOGRAPHIC",
  PRODUCT_AESTHETICS = "PRODUCT_AESTHETICS",
  VECTOR_ILLUSTRATION = "VECTOR_ILLUSTRATION",
}

export enum TagType {
  ANIME = "ANIME",
  ART = "ART",
  BLIP2 = "BLIP2",
  GENERAL = "GENERAL",
  PHOTO = "PHOTO",
  WAIFU = "WAIFU",
}

export enum TrainBaseModelType {
  SD15 = "SD15",
  SD20 = "SD20",
  SDXL = "SDXL",
}

export enum UnetWeightDtype {
  DEFAULT = "DEFAULT",
  FP8_E4M3FN = "FP8_E4M3FN",
  FP8_E5M2 = "FP8_E5M2",
}

/**
 * 发送验证码的业务场景
 */
export enum VerifyCodeScene {
  ACCOUNT_BALANCE_TRANS = "ACCOUNT_BALANCE_TRANS",
  BIND_EMAIL = "BIND_EMAIL",
  BIND_MOBILE = "BIND_MOBILE",
  CHANGE_PWD = "CHANGE_PWD",
  LOGIN_REGISTER = "LOGIN_REGISTER",
  LOGOFF = "LOGOFF",
  RECORD_PARK_USER = "RECORD_PARK_USER",
}

export enum VideoSource {
  AI_VIDEO = "AI_VIDEO",
  LOCAL = "LOCAL",
}

/**
 * 可见状态
 */
export enum VisibleStatus {
  MUZZLE_NOT_VISIBLE = "MUZZLE_NOT_VISIBLE",
  NOT_VISIBLE = "NOT_VISIBLE",
  TMP_NOT_VISIBLE = "TMP_NOT_VISIBLE",
  VISIBLE = "VISIBLE",
}

/**
 * 可见范围
 */
export enum VisibleType {
  ALL = "ALL",
  CREATE_LIKEWISE = "CREATE_LIKEWISE",
  CREATE_LIKEWISE_COST = "CREATE_LIKEWISE_COST",
  NONE = "NONE",
  ONLY_FANS = "ONLY_FANS",
  ONLY_FOLLOW_EACH_OTHER = "ONLY_FOLLOW_EACH_OTHER",
  ONLY_VOTED = "ONLY_VOTED",
}

export enum WhitelistStatus {
  IN = "IN",
  NONE = "NONE",
}

export enum WhitelistType {
  SQUARE_ACTIVITY = "SQUARE_ACTIVITY",
}

export enum WorkflowExecutePattern {
  ALL_PATTERN = "ALL_PATTERN",
  ONLY_SUBSTEP = "ONLY_SUBSTEP",
}

/**
 * 申诉入参
 */
export interface AiArtworkAppealInput {
  aiArtworkIds?: (any | null)[] | null;
  appealReason?: string | null;
  scene?: AiArtworkAppealScene | null;
}

/**
 * AI作画积分使用策略
 */
export interface AiArtworkIntegralUseStrategyInput {
  integralUseOnAccelerate?: number | null;
  integralUseOnCreate?: number | null;
  integralUseOnResolution?: number | null;
  integralUseOnStyleModel?: number | null;
  integralUseOnSuperSize?: number | null;
}

/**
 * ai作画模型融合输入
 */
export interface AiArtworkModelFusionInput {
  blockWeight?: number[] | null;
  key: string;
  weight: number;
}

/**
 * ai作画选项输入
 */
export interface AiArtworkOptionInput {
  key: string;
  type: AiArtworkOptionTypeEnum;
}

/**
 * AI作画支付策略
 */
export interface AiArtworkPayStrategyInput {
  integralUse?: AiArtworkIntegralUseStrategyInput | null;
  userRightsUse?: AiArtworkUserRightsUseStrategyInput | null;
  vipRightsUse?: AiArtworkVipRightsUseStrategyInput | null;
}

export interface AiArtworkPostSameInput {
  imageId?: any | null;
  pictureSameModel?: number | null;
  postId?: any | null;
  postType?: SquarePostType | null;
  sameType?: AiArtworkSameType | null;
}

/**
 * 列表查询参数
 */
export interface AiArtworkQueryInput {
  aiCollectionId?: any | null;
  calcSpecificSize?: any | null;
  character?: boolean | null;
  createBeginTime?: number | null;
  createEndTime?: number | null;
  exclusionCollectionAiArtwork?: boolean | null;
  exclusionInvolveYellow?: boolean | null;
  filterInstantId?: boolean | null;
  ids?: (any | null)[] | null;
  ignoreServiceType?: boolean | null;
  initImage?: boolean | null;
  involveYellows?: (InvolveYellow | null)[] | null;
  keyOfInitParam?: string | null;
  modelClassificationId?: string | null;
  modelClassificationIds?: (string | null)[] | null;
  modelFusion?: boolean | null;
  models?: (AiCreateArtworkModel | null)[] | null;
  notincludeModelClassificationIds?: (string | null)[] | null;
  orderMode?: AiArtworkOrderMode | null;
  patterns?: (AiCreateArtworkPattern | null)[] | null;
  preFine?: boolean | null;
  preTreat?: boolean | null;
  prompt?: string | null;
  publishedToSquare?: boolean | null;
  serviceStatus?: AiArtworkServiceStatus | null;
  serviceStatuses?: (AiArtworkServiceStatus | null)[] | null;
  sizes?: (string | null)[] | null;
  status?: AiArtWorkStatus | null;
  styleModelKey?: string | null;
}

/**
 * AI作画用户权益使用策略
 */
export interface AiArtworkUserRightsUseStrategyInput {
  dailyFreeCreateTimesUse?: number | null;
  deservedCreateTimesUse?: number | null;
}

/**
 * AI作画会员权益使用策略
 */
export interface AiArtworkVipRightsUseStrategyInput {
  accelerateTimesUse?: number | null;
  createTimesUse?: number | null;
  superSizeTimesUse?: number | null;
}

/**
 * ai集合列表参数
 */
export interface AiCollectionListParam {
  homePage?: boolean | null;
  opened?: boolean | null;
  targetUid?: any | null;
}

export interface AiCompetitionArtworkInput {
  aiArtworkId?: any | null;
  aiArtworkIds?: (any | null)[] | null;
  aiCompetitionId?: any | null;
  description?: string | null;
  name?: string | null;
  releaseSquare?: boolean | null;
  visibleType?: VisibleType | null;
}

/**
 * ai作画加速
 */
export interface AiCreateArtworkAccelerate {
  id: any;
  integralNum: number;
  payStrategy?: AiArtworkPayStrategyInput | null;
}

/**
 * ai作画参数
 */
export interface AiCreateArtworkParam {
  accelerateTimes?: number | null;
  anyTextMode?: AnyTextMode | null;
  artist?: string | null;
  cfg?: number | null;
  character?: string[] | null;
  chatGptOptimize?: boolean | null;
  clipSkip?: number | null;
  createSource?: number | null;
  creativityDegree?: number | null;
  cutdiffusion?: CutDiffusionInput | null;
  ensd?: number | null;
  eta?: number | null;
  flux?: FluxInput | null;
  imageType?: (string | null)[] | null;
  initHeight?: number | null;
  initImageSources?: InitImageSource[] | null;
  initImageUrl?: string | null;
  initWidth?: number | null;
  instantStyle?: InstantStyle[] | null;
  layerDiffusionInput?: LayerDiffusionInput | null;
  length: number;
  maskImageUrl?: string | null;
  maskZoneImageUrl?: string | null;
  mjParam?: MjParamInput | null;
  model?: AiCreateArtworkModel | null;
  modelCode?: number | null;
  modelFusion?: AiArtworkModelFusionInput[] | null;
  nature?: number | null;
  num?: number | null;
  pattern?: AiCreateArtworkPattern | null;
  payStrategy?: AiArtworkPayStrategyInput | null;
  pretreatmentMethod?: PretreatmentMethod | null;
  prompt: string;
  promptOptimize?: number | null;
  queueType?: QueueType | null;
  repairTheHand?: boolean | null;
  sameAiArtworkId?: any | null;
  sameAiArtworkSource?: AiArtworkSource | null;
  samplerIndex?: number | null;
  seed?: string | null;
  size?: string | null;
  spellAnalysisImgType?: SpellAnalysisImgType | null;
  steps?: number | null;
  strength?: number | null;
  style?: (string | null)[] | null;
  styleDecorationOptions?: AiArtworkOptionInput[] | null;
  styleModel?: string | null;
  superType?: SuperType | null;
  taskId?: string | null;
  tobExtend?: TobExtend | null;
  ucPrompt?: string | null;
  userTrainedModel?: UserTrainedModelInput[] | null;
  width: number;
}

/**
 * 兑换码丹炉创建
 */
export interface AiDanluCreateByConversionCodeInput {
  conversionCode: string;
  name: string;
}

/**
 * 丹炉创建
 */
export interface AiDanluCreateInput {
  gpuTypeId: any;
  name: string;
  snapshotType: number;
}

/**
 * 编辑ai丹炉信息参数
 */
export interface AiDanluUpdateParam {
  name?: string | null;
}

export interface AppRechargeInput {
  rechargeFee?: any | null;
  rechargeType?: number | null;
  rechargeVoucher?: string | null;
}

/**
 * 作品查询入参
 */
export interface ArtworkQueryInput {
  aiCompetitionId?: any | null;
  categoryIdList?: (any | null)[] | null;
  id?: any | null;
  keywordType?: ArtworkKeywordType | null;
  lora?: string | null;
  pt?: string | null;
  searchAgencyName?: string | null;
  searchArtistName?: string | null;
  searchName?: string | null;
  searchUploaderType?: SearchUploaderType | null;
  sort?: SortType | null;
  sortField?: ArtworkSortEnum | null;
  status?: ArtworkStatusEnum | null;
  type?: ArtworkDBType | null;
  types?: (ArtworkDBType | null)[] | null;
}

/**
 * 作品社交相关查询入参
 */
export interface ArtworkSocialQueryInput {
  itemTypes?: (SquareItemType | null)[] | null;
  socialType: SocialType;
}

export interface BackendMuzzleOpInput {
  content?: MuzzleContentInput | null;
  enable: boolean;
  reasonType?: number | null;
  timeType?: MuzzleTimeType | null;
  uid: any;
}

/**
 * 行为校验参数
 */
export interface BehaviorCheckParam {
  authenticate: string;
  token: string;
}

/**
 * 行为校验参数
 */
export interface BehaviorVerifyParam {
  authenticate: string;
  token: string;
}

export interface CollectionAiArtworkInput {
  aiArtworkIds: any[];
  id: any;
}

/**
 * 合集制作封面ai作画子input
 */
export interface CollectionMakeCoverAiArtwork {
  coverOrder: any;
  id: any;
}

/**
 * 合集制作封面input
 */
export interface CollectionMakeCoverInput {
  aiArtworks?: (CollectionMakeCoverAiArtwork | null)[] | null;
  customCoverImageUrl?: string | null;
  id: any;
  imageDetectionId?: any | null;
  useCustom?: boolean | null;
}

export interface ComicCollectInput {
  desc?: string | null;
  id?: any | null;
  image?: string | null;
  name?: string | null;
  type?: ComicCollectTypeEnum | null;
  updateType?: ComicCollectUpdateTypeEnum | null;
}

export interface CommentImageInput {
  aiArtworkId?: any | null;
  source?: PostImageSourceType | null;
  url?: string | null;
}

export interface CommentVideoInput {
  aiVideoId?: any | null;
  source?: VideoSource | null;
  url?: string | null;
}

export interface CompetitionAiArtworkPageInput {
  competitionId?: any | null;
  keyOfInitParam?: string | null;
}

export interface CompetitionQueryInput {
  aiArtworkId?: any | null;
  nameLike?: string | null;
  startStatus?: StartStatusEnum | null;
  type?: CompetitionType | null;
  typeList?: (CompetitionType | null)[] | null;
}

export interface ContestQueryInput {
  contestType?: ContestType | null;
  id?: any | null;
}

export interface ConversationInitiateInput {
  conversationType?: ConversationType | null;
  title?: string | null;
}

export interface ConversationQueryParam {
  conversationType?: ConversationType | null;
}

/**
 * 会话请求
 */
export interface ConversationRequest {
  conversationId?: any | null;
  conversationType: ConversationType;
  parentId?: any | null;
  prompt: string;
  referImages: (string | null)[];
}

export interface ConversationUpdateInput {
  id?: any | null;
  title?: string | null;
}

/**
 * 无界 AI 文本搜索入参
 */
export interface CopyrightAiTextSearchParam {
  character?: boolean | null;
  chineseTags?: (string | null)[] | null;
  content?: CopyrightAiSearchContent | null;
  englishTags?: (string | null)[] | null;
  highQuality?: boolean | null;
  initImage?: boolean | null;
  keyword?: string | null;
  language?: CopyrightAiSearchLanguage | null;
  model?: AiCreateArtworkModel | null;
  modelClassificationId?: string | null;
  modelClassificationIds?: (string | null)[] | null;
  modelFusion?: boolean | null;
  myAttention?: boolean | null;
  scope?: CopyrightAiSearchScope | null;
  size?: string | null;
  sort: CopyrightAiSort;
  squarePostType?: SquarePostType | null;
  styleModelKey?: string | null;
  themeId?: any | null;
  visibleType?: number | null;
}

/**
 * 创建合集参数
 */
export interface CreateCollectionInput {
  aiArtworkIds?: (any | null)[] | null;
  collectionContent?: string | null;
  collectionName: string;
  createTags?: (any | null)[] | null;
  opened: boolean;
  visible?: AiCollectionVisibleType | null;
}

export interface CutDiffusionInput {
  cfgScale1?: number | null;
  cfgScale2?: number | null;
  cutdiffProportion?: number | null;
}

export interface DanluRechargeInput {
  danluKey?: string | null;
  num?: number | null;
  payTypeInfo?: PayTypeInput | null;
  rechargeAmount?: any | null;
  rechargeHour?: number | null;
  remark?: string | null;
  skuId?: any | null;
}

export interface DanluRechargeOrderQueryInput {
  orderNo?: string | null;
  sort?: SchemaSort | null;
  status?: OrderStatusEnum | null;
}

export interface DeviceInfoInput {
  appVersion?: string | null;
  deviceId: string;
  deviceModel?: string | null;
  from: FromEnum;
  osVersion?: string | null;
  userAgent?: string | null;
}

export interface DraftArtworkProcessImageInput {
  aiArtworkId?: any | null;
  processImageUrl?: string | null;
}

export interface DraftCompetitionArtworkInput {
  aiCompetitionId?: any | null;
  artworkHistory?: (string | null)[] | null;
  artworkType?: string | null;
  award?: string | null;
  description?: string | null;
  imageUrl?: (string | null)[] | null;
  industry?: string | null;
  name?: string | null;
  processImageUrl?: (DraftArtworkProcessImageInput | null)[] | null;
  selfIntroduction?: string | null;
}

export interface FansListInput {
  uid?: any | null;
}

export interface FluxInput {
  baseShift?: number | null;
  chaos?: number | null;
  clipName1?: string | null;
  clipName2?: string | null;
  clipType?: ClipType | null;
  maxShift?: number | null;
  scheduler?: Scheduler | null;
  style?: number | null;
  threshold?: number | null;
  unetWeightDtype?: UnetWeightDtype | null;
  vaeName?: string | null;
}

export interface FocusQueryInput {
  acceptType?: (SquareItemType | null)[] | null;
}

/**
 * 取消关注
 */
export interface FollowCancelInput {
  followUid: any;
}

/**
 * 关注
 */
export interface FollowInput {
  followUid: any;
  page?: string | null;
}

export interface FollowListInput {
  uid?: any | null;
}

/**
 * 社交动作入参
 */
export interface GeneralSocialActionInput {
  actionType?: ActionType | null;
  affectedType?: AffectedType | null;
  id?: any | null;
  modelKey?: string | null;
  viewType?: SocialViewType | null;
}

/**
 * 图片
 */
export interface Image {
  url: string;
}

export interface ImageDetectionInput {
  image: Image;
  needSyncReturn?: boolean | null;
  scene: Scene;
}

/**
 * 底图来源，可作为通用input
 */
export interface InitImageSource {
  applyScene: AiItemPostTargetEnum;
  sourceAiType?: AiTypeEnum | null;
  sourceId: any;
}

export interface InstantStyle {
  controlWeight?: any | null;
  imageUrl: string;
  modelFusion?: ModelFusionInput | null;
  pulidMode?: ControlNetPulidMode | null;
  showType: ControlShowType;
}

export interface IntentionSubmitInput {
  companyName?: string | null;
  cooperationScene?: string | null;
  industryCategoryId?: any | null;
  mobile: string;
  personalName: string;
  type?: CompanyIntentionType | null;
}

export interface LayerDiffusionInput {
  endingStep?: any | null;
  weight?: any | null;
}

/**
 * 魔法骰子入参
 */
export interface MagicDiceSearchInput {
  keyword?: string | null;
  language?: Language | null;
  model?: AiCreateArtworkModel | null;
  themeId?: number | null;
}

export interface MemberCardBillQueryInput {
  groupList?: (AccountGroupTypeEnum | null)[] | null;
}

export interface MjParamInput {
  chaos?: number | null;
  crefUrls?: (string | null)[] | null;
  cw?: number | null;
  mode?: string | null;
  quality?: string | null;
  srefRandom?: number | null;
  srefUrls?: (string | null)[] | null;
  stylize?: number | null;
  sw?: number | null;
  tile?: boolean | null;
  upbeta?: boolean | null;
}

export interface ModelFusionInput {
  weight?: any | null;
}

/**
 * 修改合集参数
 */
export interface ModifyCollectionInput {
  collectionContent?: string | null;
  collectionName?: string | null;
  createTags?: (any | null)[] | null;
  id: any;
  opened?: boolean | null;
  visible?: AiCollectionVisibleType | null;
}

export interface MuzzleContentInput {
  bizId?: any | null;
  bizType?: MuzzleBizType | null;
  image?: string | null;
  title?: string | null;
}

/**
 * 个人信息的修改参数
 */
export interface MyCopyrightInfoParam {
  avatarId?: any | null;
  avatarType?: CopyrightUserAvatarType | null;
  backgroundUrl?: string | null;
  nickname?: string | null;
  personalizedSignature?: string | null;
}

/**
 * 网盘创建目录
 */
export interface NetworkDiskCreateFolderInput {
  folderName: string;
  parentPath: string;
}

/**
 * 网盘删除
 */
export interface NetworkDiskDelInput {
  names: string[];
  path: string;
}

/**
 * 网盘移动
 */
export interface NetworkDiskMoveInput {
  fromPath: string;
  names: string[];
  toPath: string;
}

export interface NetworkDiskParam {
  exclusionNames?: (string | null)[] | null;
  file?: boolean | null;
  fileSizeOrder?: SortType | null;
  fileType?: FileType | null;
  modifyTimeOrder?: SortType | null;
  parentPath: string;
}

/**
 * 网盘重命名文件/文件夹
 */
export interface NetworkDiskRenameInput {
  newName: string;
  originalName: string;
  path: string;
}

/**
 * 笔记内容输入
 */
export interface NoteContentInput {
  paragraphList?: (NoteParagraphInput | null)[] | null;
}

/**
 * 笔记内容片段参数
 */
export interface NoteParagraphInput {
  noteImageList?: (PostImageInput | null)[] | null;
  paragraphContent?: string | null;
}

export interface PayTypeInput {
  openCode?: string | null;
  payChannel?: number | null;
  payProvider?: number | null;
  payType?: number | null;
  returnUrl?: string | null;
}

/**
 * 新建贴子输入类型
 */
export interface PostCreateInput {
  activityInput?: SquareActivityCreateInput | null;
  aiCollectionId?: any | null;
  aiCollectionVisibleType?: number | null;
  bountyInput?: SquareBountyCreateInput | null;
  canDownSourceImage?: boolean | null;
  channelId?: any | null;
  comicCollectId?: any | null;
  comicCoverImage?: PostImageInput | null;
  content?: string | null;
  createLikewiseCastValue?: any | null;
  createTags?: (any | null)[] | null;
  nPostImageList?: (PostImageInput | null)[] | null;
  noteContentInput?: NoteContentInput | null;
  postImageList?: (string | null)[] | null;
  postType?: SquarePostType | null;
  relationSource?: (RelationSourceInput | null)[] | null;
  title?: string | null;
  totalLikewiseCount?: number | null;
  videoInput?: SquareVideoCreateInput | null;
  visible?: VisibleStatus | null;
  visibleType?: VisibleType | null;
  vote?: VotePostInput | null;
  workflowInput?: WorkflowCreateInput | null;
}

export interface PostImageDownloadInput {
  imageId?: any | null;
  postId?: any | null;
  postScope?: SquarePostScope | null;
}

export interface PostImageInput {
  id?: any | null;
  length?: number | null;
  minUrl?: string | null;
  needAutoCheck?: boolean | null;
  sourceId?: any | null;
  sourceType?: PostImageSourceType | null;
  specialTag?: string | null;
  specialTagEnum?: SpecialImageTagEnum | null;
  url?: string | null;
  width?: number | null;
}

/**
 * 因为缓存依赖与该模型序列化后的字符串，所以添加字段时非必要将null视为默认值
 * 否则会在上线时让缓存短时间内全部失效
 * 注意！！！ 加参数时要关注一下stupidInput方法的逻辑
 */
export interface PostQueryInput {
  acceptSquareType?: (SquareItemType | null)[] | null;
  aiArtworkSize?: string | null;
  channelId?: any | null;
  character?: boolean | null;
  createTags?: (any | null)[] | null;
  createTimeBegin?: any | null;
  exitsModelCode?: (number | null)[] | null;
  initImage?: boolean | null;
  keyWord?: string | null;
  keyWordType?: PostKeyWordType | null;
  model?: AiCreateArtworkModel | null;
  modelClassificationId?: string | null;
  modelClassificationIds?: (string | null)[] | null;
  modelFusion?: boolean | null;
  sort?: SortType | null;
  sortField?: PostSortField | null;
  styleModelCategory?: number | null;
  styleModelKey?: string | null;
  timeFilter?: PostTimeFilter | null;
  type?: SquarePostType | null;
  visibleType?: number | null;
}

/**
 * 贴子编辑入参
 */
export interface PostUpdateInput {
  canDownSourceImage?: boolean | null;
  channelId?: any | null;
  comicCollectId?: any | null;
  comicCoverImage?: PostImageInput | null;
  content?: string | null;
  createLikewiseCastValue?: any | null;
  createTags?: (any | null)[] | null;
  imageList?: (PostImageInput | null)[] | null;
  noteContentInput?: NoteContentInput | null;
  postId: any;
  relationSource?: (RelationSourceInput | null)[] | null;
  title?: string | null;
  visible?: VisibleStatus | null;
  visibleType?: VisibleType | null;
  workflowInput?: WorkflowCreateInput | null;
}

export interface PostUserQueryInput {
  aiArtworkModel?: AiCreateArtworkModel | null;
  aiArtworkSize?: string | null;
  character?: boolean | null;
  initImage?: boolean | null;
  modelClassificationId?: string | null;
  modelClassificationIds?: (string | null)[] | null;
  modelFusion?: boolean | null;
  sort?: SortType | null;
  sortField?: PostSortField | null;
  styleModelKey?: string | null;
  type?: SquarePostType | null;
  uid?: any | null;
  visibleType?: number | null;
}

export interface PublishCommentInput {
  commentImage?: (CommentImageInput | null)[] | null;
  commentVideo?: CommentVideoInput | null;
  content: string;
  evaluationScore?: EvaluationScoreEnum | null;
  parentCommentId?: any | null;
  postId?: any | null;
  postType?: SquarePostType | null;
}

export interface QueryCommentListInput {
  evaluationStatus?: CommentStatusEnum | null;
  parentCommentId?: any | null;
  postId?: any | null;
  postType?: SquarePostType | null;
}

/**
 * 实名认证补录参数
 */
export interface RealNameAuthMakeUpParam {
  idCardBackUrl?: string | null;
  idCardFrontUrl?: string | null;
  idCardValidityEndDate?: any | null;
  idCardValidityStartDate?: any | null;
}

/**
 * 实名认证参数
 */
export interface RealNameAuthParam {
  idCard: string;
  idCardBackUrl?: string | null;
  idCardFrontUrl?: string | null;
  idCardValidityEndDate?: any | null;
  idCardValidityStartDate?: any | null;
  realName: string;
  syncAuth?: boolean | null;
}

/**
 * 充值input
 */
export interface RechargeInput {
  num?: number | null;
  payTypeInfo?: PayTypeInput | null;
  rechargeAmount?: any | null;
  rechargeType?: AccountGroupTypeEnum | null;
}

/**
 * 贴子关联源输入类型
 */
export interface RelationSourceInput {
  sourceId: any;
  sourceType: SourceType;
}

export interface ReportPageViewInput {
  channelId: string;
  page: string;
}

export interface SchemaSort {
  sortField?: string | null;
  sortType?: SortType | null;
}

export interface SmartMagicInput {
  keyword?: string | null;
  model?: AiCreateArtworkModel | null;
  theme?: number | null;
}

/**
 * 社交动作入参
 */
export interface SocialActionInput {
  actionType: ActionType;
  artworkId: any;
  viewType?: SocialViewType | null;
}

/**
 * 咒语解析创建
 */
export interface SpellAnalysisCreateInput {
  height?: number | null;
  imageUrl: string;
  model?: AiCreateArtworkModel | null;
  spellAnalysisCreateChannel?: SpellAnalysisCreateChannel | null;
  tagType?: TagType | null;
  width?: number | null;
}

export interface SquareActivityCreateInput {
  address?: string | null;
  city?: string | null;
  endTime?: any | null;
  linkContent?: string | null;
  linkUrl?: string | null;
  postersUrl?: string | null;
  price?: any | null;
  province?: string | null;
  startTime?: any | null;
  way?: PostActivityWay | null;
}

export interface SquareBountyCreateInput {
  answerType?: BountyAnswerType | null;
  answerUser?: BountyAnswerUserType | null;
  bountyIntegral?: any | null;
  bountyNum?: number | null;
  validTime?: number | null;
}

/**
 * 标签定制的一些查询条件
 */
export interface SquareOptionQueryInput {
  modelCode?: number | null;
  sizeLimit?: string | null;
}

/**
 * 帖子投诉input
 */
export interface SquarePostComplaintInput {
  complaintReasonTemplate?: number | null;
  postId: any;
  reason?: string | null;
  typeIndex: number;
}

export interface SquareVideoCreateInput {
  collectionId?: any | null;
  crAiVideoId?: any | null;
  duration?: number | null;
  videoSource?: VideoSource | null;
  videoUrl?: string | null;
}

export interface SuperSizeAiArtworkInput {
  items: SuperSizeAiArtworkItem[];
  payStrategy: AiArtworkPayStrategyInput;
}

export interface SuperSizeAiArtworkItem {
  aiArtWorkId: any;
  multiple: number;
}

export interface TagCategoryQueryInput {
  parentId?: any | null;
  type?: TagModelCategory | null;
}

export interface TagFrequencyInput {
  tagEnNames?: (string | null)[] | null;
}

export interface TagQueryInput {
  category?: number | null;
  defaultTag?: boolean | null;
  rootId?: any | null;
  sortField?: SortField | null;
  sortType?: SortType | null;
  tagName?: string | null;
  type?: TagModelCategory | null;
}

export interface TextDetectionInput {
  scene: Scene;
  text: string;
}

export interface TobExtend {
  chapterId?: string | null;
}

export interface TopCollectionInput {
  id: any;
  top: boolean;
}

/**
 * 更新至描述词相同的贴子
 */
export interface UpdateToSimilarPostInput {
  aiArtworkId?: any | null;
  postId?: any | null;
}

export interface UserTrainedModelInput {
  blockWeight?: number[] | null;
  id: any;
  weight: number;
}

export interface VideoCompetitionArtworkInput {
  aiCollectionId?: any | null;
  aiCompetitionId?: any | null;
  artworkHash?: string | null;
  coverImage?: string | null;
  description?: string | null;
  linkUrl?: string | null;
  name?: string | null;
  videoUrl?: string | null;
}

export interface VotePostInput {
  endTime?: any | null;
  voteNum?: number | null;
  voteOptional?: (VotePostOptionalInput | null)[] | null;
  voteResultShow?: PostVoteResultShowEnum | null;
  voteRule?: PostVoteRuleEnum | null;
  voteType?: PostVoteTypeEnum | null;
}

export interface VotePostOptionalInput {
  no?: number | null;
  voteImage?: PostImageInput | null;
  word?: string | null;
}

export interface WorkflowCreateInput {
  executePattern?: WorkflowExecutePattern | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
